import type { DriveSourceViewMode } from '@/user_files/drive/types'

const kStorageKeyPrefix = 'matterFilesSource'

function storageKey(userId: string | undefined, matterId: string | undefined): string | null {
  return userId && matterId ? `${kStorageKeyPrefix}:${userId}:${matterId}` : null
}

/** A missing identity or unreadable preference leaves the page free to use its default source. */
export function readDriveSourcePreference(userId: string | undefined, matterId: string | undefined): DriveSourceViewMode | null {
  const key = storageKey(userId, matterId)
  if (!key) return null

  try {
    const stored = localStorage.getItem(key)
    return stored === 'matter' || stored === 'external' ? stored : null
  } catch {
    console.error('Failed to read matter file source preference.')
    return null
  }
}

/** Persistence is best effort so storage failures cannot interrupt source navigation. */
export function writeDriveSourcePreference(userId: string | undefined, matterId: string | undefined, mode: DriveSourceViewMode): void {
  const key = storageKey(userId, matterId)
  if (!key) return

  try {
    localStorage.setItem(key, mode)
  } catch {
    console.error('Failed to write matter file source preference.')
  }
}
